import { useEffect } from 'react';

const CheckPlusFail = () => {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const EncodeData = urlParams.get('EncodeData');

    if (EncodeData) {
      fetch('/auth/nice/callback', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ EncodeData })
      })
        .then(res => res.json())
        .then(data => {
          window.opener?.postMessage(data, '*');
          window.close();
        })
        .catch(err => {
          alert('본인인증 처리 중 오류 발생');
          window.close();
        });
    }
  }, []);

  return (<div>본인인증 결과를 처리 중입니다...</div>);
}

export default CheckPlusFail;